export default __webpack_public_path__ + "static/media/businesswoman.0dca8079.jpg";